// extracted by mini-css-extract-plugin
module.exports = {"body":"Layout_body__136Rd","btn":"Layout_btn__2_gQv","btn_custom":"Layout_btn_custom__5UOp-","btn_class":"Layout_btn_class__3VWcs"};